module.exports = __webpack_public_path__ + "58c4ff370c1b4f781b6e3fc44ef74c8c.svg";